import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as _ from 'lodash';
import { ContentPostPreview, Spinner } from 'components';
import { ContentPostActions } from 'containers';
import { connect } from 'react-redux';
var ContentPostDetail = (_dec = connect(function (state) {
  return {
    singlePosts: state.contentLibraryContent.singlePosts || [],
    categoryContent: state.contentLibraryContent.categoryContent,
    socialAccounts: state.organization.current ? state.organization.current.SocialAccounts : []
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentPostDetail, _Component);

  var _super = _createSuper(ContentPostDetail);

  function ContentPostDetail(props) {
    _classCallCheck(this, ContentPostDetail);

    return _super.call(this, props);
  }
  /** *******************************************************************************************
   RENDER
  ********************************************************************************************/


  _createClass(ContentPostDetail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fullPost = _this$props.fullPost,
          postId = _this$props.postId,
          categorySlug = _this$props.categorySlug;
      var platforms = this.props.socialAccounts.map(function (sa) {
        return sa.platform.split(' ')[0].toLowerCase();
      });
      var posts = postId && this.props.categoryContent && this.props.categoryContent[categorySlug] && this.props.categoryContent[categorySlug].data ? [].concat(_toConsumableArray(this.props.categoryContent[categorySlug].data), _toConsumableArray(this.props.singlePosts)) : [];
      var post = posts && posts.length ? posts.find(function (p) {
        return parseInt(p.id, 10) === parseInt(postId, 10);
      }) : fullPost || null;
      return /*#__PURE__*/React.createElement("div", null, post ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ContentPostPreview, {
        post: post,
        style: {
          marginTop: 20
        }
      }), /*#__PURE__*/React.createElement(ContentPostActions, {
        post: post
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 85
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return ContentPostDetail;
}(Component)) || _class);
ContentPostDetail.defaultProps = {
  fullPost: null,
  postId: null
};
export default ContentPostDetail;